import React from 'react';
import { Box, Typography, Card, CardContent } from '@mui/material';
import RBACAssignment from './RBACAssignment';
import { useAccessControl, RESOURCES, ACTIONS } from '../../hooks/useAccessControl';

const RBACPage = () => {
  const { can, loading } = useAccessControl();

  const canReadPermissionCatalog = can(RESOURCES.PERMISSIONS, ACTIONS.READ);
  const canReadUsers = can(RESOURCES.USERS, ACTIONS.READ);
  const canAssignDirectPermissions = can(RESOURCES.USERS, ACTIONS.ASSIGN);
  const canUpdateUserRoles = can(RESOURCES.USERS, ACTIONS.UPDATE);

  const canAccess = canReadPermissionCatalog && canReadUsers && (canAssignDirectPermissions || canUpdateUserRoles);

  if (loading) {
    return (
      <Box display="flex" justifyContent="center" alignItems="center" minHeight="400px">
        <Typography>Loading...</Typography>
      </Box>
    );
  }

  if (!canAccess) {
    return (
      <Card elevation={3}>
        <CardContent sx={{ textAlign: 'center', py: { xs: 3, md: 4 } }}>
          <Typography variant="h5" color="error" gutterBottom>
            Access Denied
          </Typography>
          <Typography variant="body1" color="text.secondary">
            You need user-read, permission-catalog-read, and role-update or permission-assign rights.
          </Typography>
        </CardContent>
      </Card>
    );
  }

  return (
    <Box sx={{ px: { xs: 0, sm: 1 } }}>
      <Box mb={3}>
        <Typography variant="h4" gutterBottom sx={{ fontWeight: 600, color: 'primary.main' }}>
          User Permissions
        </Typography>
        <Typography variant="body2" color="text.secondary">
          Assign roles and permissions to users
        </Typography>
      </Box>
      <RBACAssignment />
    </Box>
  );
};

export default RBACPage;
